<template>
    <div class="container">
        <img :src="_global.isMobile ? _global.assetsRoot + '/choose_your_prize/mobile/MB_prize_bg.png' : _global.assetsRoot + '/choose_your_prize/desktop/PC_prize_bg.png'" alt="Claw Product" class="background">
        <img :src="_global.isMobile ? _global.assetsRoot + '/choose_your_prize/mobile/btn_return.png' : _global.assetsRoot + '/choose_your_prize/desktop/btn_return.png'" alt="Return Button" class="return-button" @click="goToHome()">
        <div class="content" v-if="selectedProduct">
            <div class="ic-coins">
                <img class="loader-image" :src="_global.isMobile 
                            ? _global.assetsRoot + '/choose_your_prize/mobile/ic_coins.png' 
                            : _global.assetsRoot + '/choose_your_prize/desktop/ic_coins.png'" alt="" />
                <span>{{ coins(selectedProduct.reward_coins) }}</span>
            </div>
            <img :src="selectedProduct.product_image" alt="Product Icon" class="center-image">
            <div class="title">{{getTitle()}}</div>
            <div class="subtitle">{{getDescription()}}</div>
        </div>
    </div>
</template>

<script>
import api from '../network/api.js';
import utils from '../utils/utils.js';

export default {
    data() {
        return {
            pid: null,
            clawProducts: [],
            user: null,
            products: null,
            loyalty: null,
            vip_store: null,
            selectedProduct: null
        }
    },
    created() {
        this.pid = this.$route.query.pid || null;

        this.user = this._global.user || null;
        this.products = this._global.products || null;
        this.loyalty = this._global.loyalty || null;
        this.vip_store = this._global.vip_store || null;
    },
    mounted() {
        if (this._global.sid) {
            api.getClawProducts(this._global.sid).then((resp) => {
                if (resp.data.status === "ok") {
                    this.clawProducts = resp.data.products;

                    this.clawProducts.forEach((product) => {
                        if(product.product_id == this.pid){
                            this.selectedProduct = product;
                        }
                    })

                    console.log(this.selectedProduct);
                }
            });
        }
    },
    methods: {
        getTitle() {
            let userLanguage = this._global.user.lang;

            switch(userLanguage){
                case 'pt':
                    return this.selectedProduct.product_name.pt;
                    break;
                default:
                    return this.selectedProduct.product_name.en;
                    break
            }
        },
        getDescription() {
            let userLanguage = this._global.user.lang;

            switch(userLanguage){
                case 'pt':
                    return this.selectedProduct.product_desc.pt;
                    break;
                default:
                    return this.selectedProduct.product_desc.en;
                    break
            }
        },
        goToHome(){
            //window.location.href = '/';
            window.close();
        },
        coins(value) { return utils.fc(value) || 0 }
    }
}
</script>

<style lang="scss">
@import "../assets/css/variables.scss";
@import url('https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap');

.container {
    position: relative;
    width: 100%;
    height: 100vh;
    background: #000000;
}

.background {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

.content {
    position: absolute;
    top: 30%;
    left: 30%;
    width: 40%;
    text-align: center;
    z-index: 10;
}

.center-image {
    width: 45%;
    height: auto;
    margin: 0 auto 20px;
    display: block;
}

.return-button {
    cursor: pointer;
    position: absolute;
    top: 8%;
    left: 31%;
    width: 3%;
}

.title {
    font-family: "Luckiest Guy", cursive;
    font-size: clamp(35px, 3vw, 65px);
    color: #ffbe18;
    text-align: center;
    line-height: 1.1;
    word-break: break-word;
    text-shadow:
        -4px -4px 0 #b72e02,
        0px -4px 0 #b72e02,
        4px -4px 0 #b72e02,
        -4px  0px 0 #b72e02,
        4px  0px 0 #b72e02,
        -4px  4px 0 #b72e02,
        0px  4px 0 #b72e02,
        4px  4px 0 #b72e02;
}

.subtitle {
    font-family: "Luckiest Guy", cursive;
    text-align: center;
    line-height: 1.2;
    font-size: clamp(30px, 2.5vw, 55px);
    color: #ffffff;
    text-shadow:
        -4px -4px 0 #b72e02,
        0px -4px 0 #b72e02,
        4px -4px 0 #b72e02,
        -4px  0px 0 #b72e02,
        4px  0px 0 #b72e02,
        -4px  4px 0 #b72e02,
        0px  4px 0 #b72e02,
        4px  4px 0 #b72e02;
}

.ic-coins{
    position: absolute;
    top: 2%;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    img{
        width: 40px;
        height: 40px;
    }

    span{
        font-family: "Arial";
        font-weight: bold;
        margin-left: 0;
        text-align: center;
        line-height: 1.2;
        font-size: clamp(35px, 2vw, 55px);
        color: #fcfc7b;
        text-shadow:
            -2px -2px 0 #a65103,
            0px -2px 0 #a65103,
            2px -2px 0 #a65103,
            -2px  0px 0 #a65103,
            2px  0px 0 #a65103,
            -2px  2px 0 #a65103,
            0px  2px 0 #a65103,
            2px  2px 0 #a65103;
    }
}

.mobile{
    .background{
        object-fit: unset;
    }

    .content{
        width: 80%;
        top: 25%;
        left: 12%;
    }

    .center-image{
        width: 70%;
    }

    .return-button{
        top: 11%;
        width: 6%;
        left: 3%;
    }

    .title{
        font-size: clamp(30px, 2.5vw, 45px);
    }

    .subtitle{
        font-size: clamp(25px, 1.5vw, 35px);
    }

    .ic-coins{
        img{
            width: 30px;
            height: 30px;
        }

        span{
            font-size: clamp(25px, 2vw, 55px);
        }
    }

    @media screen and (min-width: 650px) and (max-width: 1024px) {
        .return-button {
            top: 5%;
            width: 4%;
            left: 3%;
        }

        .content {
            width: 45%;
            top: 25%;
            left: 25%;
        }

        .center-image {
            width: 50%;
        }

        .title{
            font-size: clamp(25px, 4vw, 45px);
        }

        .subtitle{
            font-size: clamp(20px, 3vw, 35px);
        }

        .ic-coins{
            img{
                width: 25px;
                height: 25px;
            }

            span{
                font-size: clamp(20px, 2vw, 55px);
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/ClawProduct.vue